import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon, ArrowRightIcon, MessageCircleIcon } from 'lucide-react';
import { ContactFormPopup } from './ContactFormPopup';
const words = ['Бьюти-мастера', 'Сантехника', 'Юриста', 'Вашего бизнеса'];
export function HeroVariant2() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % words.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="relative min-h-screen w-full overflow-hidden px-4 pt-24 pb-16 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-437">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12" data-id="element-438">
          {/* Left Content */}
          <div className="w-full lg:w-1/2 text-left" data-id="element-439">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-440">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-[1.2]" style={{
              color: 'var(--text-primary)'
            }} data-id="element-441">
                Сделаем бесплатный сайт для <br data-id="element-442" />
                <span className="inline-block relative h-[1.2em] w-full overflow-hidden text-[var(--accent)] mt-2" data-id="element-443">
                  <AnimatePresence mode="wait" data-id="element-444">
                    <motion.span key={index} initial={{
                    y: 40,
                    opacity: 0
                  }} animate={{
                    y: 0,
                    opacity: 1
                  }} exit={{
                    y: -40,
                    opacity: 0
                  }} transition={{
                    duration: 0.4,
                    ease: 'easeOut'
                  }} className="absolute left-0 top-0" data-id="element-445">
                      {words[index]}
                    </motion.span>
                  </AnimatePresence>
                </span>
              </h1>
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="text-lg md:text-xl mb-8 text-gray-600 font-medium max-w-lg" data-id="element-446">
              Сначала макет — потом решение. Платишь только $10/мес за
              поддержку, если всё понравится.
            </motion.p>

            {/* Checkmarks */}
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="space-y-4 mb-10" data-id="element-447">
              {['Без предоплаты и рисков', 'Первый макет готов за 1-3 дня', 'Платите $10/мес только после утверждения'].map((text, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.5 + i * 0.1
            }} className="flex items-center gap-3" data-id="element-448">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-449" />
                  <span className="text-base md:text-lg font-medium text-gray-800" data-id="element-450">
                    {text}
                  </span>
                </motion.div>)}
            </motion.div>

            <motion.button initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.8
          }} onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-3 rounded-2xl px-8 py-4 font-bold text-lg transition-all hover:scale-105 shadow-lg w-full sm:w-auto" style={{
            backgroundColor: 'var(--accent)',
            color: '#FFFFFF'
          }} data-id="element-451">
              Хочу бесплатный макет
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-452" />
            </motion.button>
          </div>

          {/* Right Video with Floating Elements */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="w-full lg:w-1/2 relative" data-id="element-453">
            <div className="relative w-full max-w-lg mx-auto rounded-3xl overflow-hidden shadow-2xl border-4 border-white bg-white" data-id="element-454">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-455" />
            </div>

            {/* Floating Card 1 */}
            <motion.div animate={{
            y: [0, -15, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -left-8 top-12 bg-white p-4 rounded-2xl shadow-xl border border-gray-100 flex items-center gap-3 hidden md:flex" data-id="element-456">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-457">
                <MessageCircleIcon className="w-5 h-5 text-green-600" data-id="element-458" />
              </div>
              <div data-id="element-459">
                <p className="text-xs text-gray-500 font-medium" data-id="element-460">
                  Новая заявка
                </p>
                <p className="text-sm font-bold text-gray-900" data-id="element-461">
                  Клиент с сайта
                </p>
              </div>
            </motion.div>

            {/* Floating Card 2 */}
            <motion.div animate={{
            y: [0, 15, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute -right-8 bottom-20 bg-white p-4 rounded-2xl shadow-xl border border-gray-100 flex items-center gap-3 hidden md:flex" data-id="element-462">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-xl" data-id="element-463">
                💸
              </div>
              <div data-id="element-464">
                <p className="text-xs text-gray-500 font-medium" data-id="element-465">Подписка</p>
                <p className="text-sm font-bold text-gray-900" data-id="element-466">Всего $10/мес</p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-467" />
    </>;
}